const CATEGORY_HERO_IMAGES = {
  gaming: 'gaming.png',
  phones: 'smartphones.png',
  electronics: 'home.png',
  audio: 'audio.png',
  computing: 'computers.png',
  fashion: 'fashion.png',
  sports: 'sports.png',
  beauty: 'beauty.png',
  baby: 'babies_and_kids.png',
  pets: 'pets.png',
  kitchen: 'kitchen.png',
  tools: 'tools-diy.png',
  toys: 'toys.png',
};

export function getCategoryHeroImage(categoryKey) {
  const filename = CATEGORY_HERO_IMAGES[categoryKey];
  if (!filename) {
    return null;
  }
  return `/img/categories/${filename}`;
}

export function hasCategoryHeroImage(categoryKey) {
  return Boolean(CATEGORY_HERO_IMAGES[categoryKey]);
}
